// Category slug rename map (2026-07-22, user rule: category URLs must be singular for
// SEO, same as display names — "אורתודנט" not "אורתודנטים"). 115 categories renamed in
// one pass; since article/pro URLs derive their category segment dynamically from
// he_categories.slug (never stored redundantly per-row), renaming the category alone
// fixed every downstream URL automatically — this map is ONLY needed so old bookmarked/
// indexed URLs 301 to the new ones instead of 404ing. Hardcoded (not a DB lookup) to
// match this codebase's existing middleware constraint (edge runtime, no mysql2/node
// crypto — see middleware.ts's AMP section comment). Source of truth for what changed:
// DB table he_category_redirects (old_slug, category_id, created_at).
export const CATEGORY_SLUG_REDIRECTS: Record<string, string> = {
  // 2026-09-22 Founder rename: the balcony-glazing category is named for the glass product
  "סגירת-מרפסות": "סגירת-מרפסת-זכוכית",
  "חשמלאים": "חשמלאי",
  "אינסטלטורים": "אינסטלטור",
  "עורכי-דין": "עורך-דין",
  "רואי-חשבון": "רואה-חשבון",
  "מתקיני-דלתות": "מתקין-דלתות",
  "נגרים": "נגר",
  "צבעים": "צבע",
  "שרברבים": "שרברב",
  "גננים": "גנן",
  "קבלני-שיפוצים": "קבלן-שיפוצים",
  "שיפוצניקים": "שיפוצניק",
  "קבלני-גבס": "קבלן-גבס",
  // 2026-10-15 cat-unify: מכולות/השכרת-מכולה/קבלן-בניה-קלה merged into מבנים-יבילים (1077);
  // the old plural slug points straight at the final target (single-pass lookup, no chaining)
  "קבלני-בניה-קלה": "מבנים-יבילים",
  "קבלן-בניה-קלה": "מבנים-יבילים",
  "מכולות": "מבנים-יבילים",
  "השכרת-מכולה": "מבנים-יבילים",
  "קבלני-שלד": "קבלן-שלד",
  "קבלני-איטום": "קבלן-איטום",
  "קבלני-אלומיניום": "קבלן-אלומיניום",
  "קבלני-שיש": "קבלן-שיש",
  "קבלני-ממדים": "קבלן-ממדים",
  "קבלני-מצבות": "קבלן-מצבות",
  "מפקחי-בניה": "מפקח-בניה",
  "קונסטרוקטורים": "קונסטרוקטור",
  "אדריכלים": "אדריכל",
  "הנדימנים": "הנדימן",
  "מסגרים": "מסגר",
  "גגנים": "גגן",
  "מנסרי-בטון": "מנסר-בטון",
  "מפני-דירות": "מפנה-דירות",
  "מצפי-דלתות": "מצפה-דלתות",
  "זגגים": "זגג",
  "תריסים": "מתקין-תריסים",
  "מתקיני-סוככים": "מתקין-סוככים",
  "מתקיני-פרגולות": "מתקין-פרגולות",
  "מתקיני-פרקטים": "מתקין-פרקטים",
  "מדביקי-טפטים": "מדביק-טפטים",
  "מעצבי-פנים": "מעצב-פנים",
  "מסדרות-בתים": "מסדר-בתים",
  "מאתרי-נזילות": "מאתר-נזילות",
  "מתקיני-מקלחונים": "מתקין-מקלחונים",
  "אמבטיונרים": "אמבטיונר",
  "מתקיני-מערכות-חימום": "מתקין-מערכות-חימום",
  "בודקי-חשמל": "בודק-חשמל",
  "בודקי-קרינה": "בודק-קרינה",
  "מעבדות-סלולר": "מעבדת-סלולר",
  "זגגי-רכב": "זגג-רכב",
  "מוסכים": "מוסך",
  "מוסכים-ניידים": "מוסך-נייד",
  "מוסכי-קטנועים": "מוסך-קטנועים",
  "פחחי-רכב": "פחח-רכב",
  "מנעולני-רכב": "מנעולן-רכב",
  "גוזמי-עצים": "גוזם-עצים",
  "מקימי-גינות": "מקים-גינות",
  "נגרי-פרגולות": "נגר-פרגולות",
  "מדבירים": "מדביר",
  "מרחיקי-יונים": "מרחיק-יונים",
  "מובילים": "מוביל",
  "מובילים-קטנים": "מוביל-להובלות-קטנות",
  "נגרים-למטבחים": "נגר-למטבחים",
  "חברות-מטבחים": "חברת-מטבחים",
  "מנעולנים": "מנעולן",
  "עורכי-דין-עבודה": "עורך-דין-עבודה",
  "עורכי-דין-חובות": "עורך-דין-חובות",
  "עורכי-דין-מסחרי": "עורך-דין-מסחרי",
  "עורכי-דין-מקרקעין": "עורך-דין-מקרקעין",
  "עורכי-דין-משפחה": "עורך-דין-משפחה",
  "עורכי-דין-נזיקין": "עורך-דין-נזיקין",
  "עורכי-דין-תעבורה": "עורך-דין-תעבורה",
  "נוטריונים": "נוטריון",
  "יועצי-מס": "יועץ-מס",
  "יועצי-משכנתאות": "יועץ-משכנתאות",
  "מנהלי-חשבונות": "מנהל-חשבונות",
  "סוכני-ביטוח": "סוכן-ביטוח",
  "מתווכים": "מתווך",
  "מודדים": "מודד-מוסמך",
  "רופאי-שיניים": "רופא-שיניים",
  "אורתודנטים": "אורתודנט",
  "אופטומטריסטים": "אופטומטריסט",
  "פיזיותרפיסטים": "פיזיותרפיסט",
  "נטורופתים": "נטורופת",
  "רפלקסולוגים": "רפלקסולוג",
  "מעסים": "מעסה-מקצועי",
  "דיאטניות": "דיאטנית",
  "מוהלים": "מוהל",
  "מאמני-כושר": "מאמן-כושר",
  "יועצות-זוגיות": "יועצת-זוגית",
  "יועצות-שינה": "יועצת-שינה",
  "מדריכות-הורים": "מדריכת-הורים",
  "מדריכות-הנקה": "מדריכת-הנקה",
  "מורים-לנהיגה": "מורה-לנהיגה",
  "מאפרות": "מאפרת",
  "קוסמטיקאיות": "קוסמטיקאית",
  "רפדים": "רפד",
  "מפיקות-אירועים": "מפיקת-אירועים",
  "מעצבות-אירועים": "מעצבת-אירועים",
  "אטרקציות-לאירועים": "ספק-אטרקציות-לאירועים",
  "ימי-הולדת": "מפעיל-ימי-הולדת",
  "תקליטנים": "תקליטן",
  "צלמים": "צלם",
  "מעצבים-גרפיים": "מעצב-גרפי",
  "מגשי-אירוח": "ספק-מגשי-אירוח",
  "שפים-פרטיים": "שף-פרטי",
  "מכוני-גירים": "מכון-גירים",
  "וטרינרים": "וטרינר",
  "מאלפי-כלבים": "מאלף-כלבים",
  "ספרי-כלבים": "ספר-כלבים",
  "פנסיוני-כלבים": "פנסיון-כלבים",
  "בתי-דפוס": "בית-דפוס",
  "דולות": "דולה",
  "מפעילי-בריכות": "מפעיל-בריכות",
  "מקימי-בריכות": "מקים-בריכות",
  "בוני-אקווריומים": "בונה-אקווריומים",
  "מפעילי-מנוף": "מפעיל-מנוף",
  "מכווני-פסנתרים": "מכוון-פסנתרים",
  "צבעים-חיצוניים": "צבע-לעבודות-חיצוניות",
  "שירותי-גרירה": "גורר",
  "עורכי-דין-פלילי": "עורך-דין-פלילי",
};
